import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Button from "reactstrap/es/Button"

class PaginationTable extends Component {
    _onChangePage = (name, value) => {

        const filter = Object.assign({}, this.props.filter)

        delete filter['beforeId']
        delete filter['afterId']

        filter[name] = value

        const {onChangeFilter, onChangePreCurrentPage, onChangeNextCurrentPage} = this.props
        if(name === 'beforeId') onChangePreCurrentPage()
        if(name === 'afterId') onChangeNextCurrentPage()

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(filter)
        }
    }

    render() {
        const {filter, prev, next, loading, currentPage} = this.props

        return (
            <div className="CustomPagination">
                <Button
                    disabled={(!filter.hasOwnProperty('beforeId') && !filter.hasOwnProperty('afterId')) || prev === null || loading || currentPage === 1}
                    className="mr-3"
                    color="link"
                    onClick={() => this._onChangePage('beforeId', prev)}
                >
                    <i className="fa fa-long-arrow-left mr-1"/>Previous
                </Button>
                <Button
                    disabled={next === null || loading}
                    color="link"
                    onClick={() => this._onChangePage('afterId', next)}
                >
                    Next<i className="fa fa-long-arrow-right ml-1"/>
                </Button>
            </div>
        )
    }
}

PaginationTable.propTypes = {
    loading: PropTypes.bool,
    filter: PropTypes.object.isRequired,
    prev: PropTypes.string,
    next: PropTypes.string,
    onChangeFilter: PropTypes.func.isRequired
}

export default PaginationTable
